import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "portalTaskGrid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.DoneLoading)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
          ($setup.PortalTasks.length > 0)
            ? (_openBlock(), _createBlock($setup["Resource"], {
                key: 0,
                res: "home_mywork",
                args: [$setup.UserName]
              }, null, 8 /* PROPS */, ["args"]))
            : _createCommentVNode("v-if", true),
          ($setup.PortalTasks.length == 0)
            ? (_openBlock(), _createBlock($setup["Resource"], {
                key: 1,
                res: "home_mywork_empty"
              }))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      (!$setup.DoneLoading)
        ? (_openBlock(), _createBlock($setup["LoadSpinner"], { key: 0 }))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.GenerateCardsFromTasks($setup.PortalTasks, $setup.TaskProjections, $setup.GroupMethod, $setup.SortMethod), (card) => {
            return (_openBlock(), _createBlock($setup["TaskGroupCard"], { taskCard: card }, null, 8 /* PROPS */, ["taskCard"]))
          }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}